import {
  fetch,
  extractHubURL,
} from '../../utils/dataAccess';
import { success as deleteSuccess } from './delete';

export function error(error) {
  return { type: 'LIVEINTERVIEWCOMMENT_LIST_ERROR', error };
}

export function loading(loading) {
  return { type: 'LIVEINTERVIEWCOMMENT_LIST_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'LIVEINTERVIEWCOMMENT_LIST_SUCCESS', retrieved };
}

export function list(page = 'live_interview_comments') {
  return dispatch => {
    dispatch(loading(true));
    dispatch(error(''));

    fetch(page)
      .then(response =>
        ({ retrieved: response.data, hubURL: extractHubURL(response) })
      )
      .then(({ retrieved, hubURL }) => {

        dispatch(loading(false));
        dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset(eventSource) {
  return dispatch => {
    if (eventSource) eventSource.close();

    dispatch({ type: 'LIVEINTERVIEWCOMMENT_LIST_RESET' });
    dispatch(deleteSuccess(null));
  };
}
